export enum LocalStorageKeys {
  AppState = 'Linehaul Pay Portal AppState',
}
